/* eslint-disable no-use-before-define */
/* eslint-disable prefer-template */
import {
  AsYouType,
  Metadata,
  parsePhoneNumberFromString as parsePhoneNumber,
  isValidPhoneNumber,
} from "libphonenumber-js/max";
import { computePosition, size } from "@floating-ui/dom";

import countryWithNames  from "./react/checkout/data/countries";
import isMobileDevice from "../utils/isMobileDevice";

// window.libphonenumber = { AsYouType, parsePhoneNumber, isValidPhoneNumber}


const defaultCountryCode = "UA";

// createSelectOptions
const countryWithCodeList = createSelectOptions();

const PhoneInput = (phoneInputEl) => {
  let formatter;
  let currentCountry;
  let inputValue = "";
  const initPhoneNumberObj = parsePhoneNumber("+" + phoneInputEl.value.replace(/\D/g, ""))
  const initPhoneNumber = initPhoneNumberObj?.number
  const initCountryCode = initPhoneNumberObj?.country

  const flagUrl = (code = "PHONE") =>
    `/images/flag/${code}.svg`;

  const selectors = {
    elSelectCustomOpts: ".hybrid_select_list_js",
    elSelectCustomTrigger: ".hybrid_select_trigger_js",
    elSelectCustomWrapper: ".hybrid_select_wrapper_js",
    elFlag: ".curr_flag_js",
  };

  const refs = {
    parentNode: phoneInputEl.parentNode,
    elSelectCustomWrapper: null,
    elSelectCustomTrigger: null,
    elSelectCustomOpts: null,
    selectEl: null,
    elFlag: null,
  };

  const createCustomSelectTrigger = () =>
    `<span class="phone-code-select__curr form-label__input masked ind_input hybrid_select_trigger_js"><span class="phone-code-select__curr-flag curr_flag_js"></span></span>`;

  const createSelect = (optionList) =>
    `<select class="country-native-select__list">${optionList
      .map(
        ({ code, name, callingCode }) =>
          `<option value="${code}" >${name} +${callingCode}</option>`
      )
      .join("")}
    </select>`;
  const createCustomSelect = (optionList) =>
    `<ul class="hybrid_select_list_js phone-code-select__list" aria-hidden="true">${optionList
      .map(
        ({ code, name, callingCode }) =>
          `<li class="phone-code-select__list-item" data-value=${code}>
          <img class="prefix-flag" alt="${code}" loading="lazy" src="${flagUrl(
            code
          )}" />
          ${name} +${callingCode}
         </li>`
      )
      .join("")}</ul>`;

  const createCodeSelectorNode = () => {
    refs.elSelectCustomWrapper = document.createElement("div");
    refs.elSelectCustomWrapper.classList.add(
      "phone-code-select",
      "hybrid_select_wrapper_js"
    );
    refs.elSelectCustomWrapper.insertAdjacentHTML(
      "afterbegin",
      createCustomSelectTrigger()
    );
    // Create custom select
    refs.elSelectCustomWrapper.insertAdjacentHTML(
      "beforeend",
      createCustomSelect(countryWithCodeList)
    );
    // Create native select
    if (isMobileDevice()) {
      refs.elSelectCustomWrapper.insertAdjacentHTML(
        "beforeend",
        createSelect(countryWithCodeList)
      );
    }
    phoneInputEl.before(refs.elSelectCustomWrapper);
  };

  function setNewCustomOption(newCountryCode) {
    const elPrevOption =
      currentCountry &&
      refs.elSelectCustomOpts.querySelector(
        `[data-value="${currentCountry.code}"]`
      );
    const elNewOption = refs.elSelectCustomOpts.querySelector(
      `[data-value="${newCountryCode}"]`
    );
    elPrevOption && elPrevOption.classList.remove("current");
    elNewOption && elNewOption.classList.add("current");
  }

  function setNewFlag(newCountryCode) {
    refs.elFalg.style = `background-image: url('${flagUrl(newCountryCode)}')`;
  }

  // eslint-disable-next-line no-param-reassign
  const setElValue = (el, value) => {el && (el.value = value)};

  const setCurrentCountry = (newCountryCode, newInputValue) => {
    refs.elSelectCustomOpts && setNewCustomOption(newCountryCode);
    setElValue(refs.selectEl, newCountryCode);
    setNewFlag(newCountryCode);

    currentCountry = countryWithCodeList.find(
      (item) => item.code === newCountryCode
    );
    if (!newCountryCode) return
    if (newInputValue) return;
    inputValue =
      newInputValue ||
      (!formatter && initPhoneNumber
        ? initPhoneNumber
        : `+${currentCountry.callingCode}`);
    formatter = new AsYouType(newCountryCode)
    Object.assign(phoneInputEl, { formatter });
    inputValue = formatter.input(inputValue)
    setElValue(phoneInputEl, inputValue);
    // if (document.activeElement !== phoneInputEl) phoneInputEl.focus()
  };

  const openSelectCustom = () => {
    refs.elSelectCustomOpts.setAttribute("aria-hidden", false);
    refs.elSelectCustomWrapper.classList.add("active");
    computePosition(refs.elSelectCustomTrigger, refs.elSelectCustomOpts, {
      middleware: [
        size({
          apply({ availableHeight, elements }) {
            Object.assign(elements.floating.style, {
              height: `${availableHeight - 5}px`,
            });
          },
        }),
      ],
    });

    document.addEventListener("click", watchClickOutside);
  };
  const closeSelectCustom = () => {
    refs.elSelectCustomOpts.setAttribute("aria-hidden", true);
    refs.elSelectCustomWrapper.classList.remove("active");
    document.removeEventListener("click", watchClickOutside);
  };

  const selectChangeHandler = (e) => {
    setCurrentCountry(e.target.value);
  };

  const customSelectTriggerClickHandler = () => {
    const isOpen = refs.elSelectCustomWrapper.classList.contains("active");
    (isOpen ? closeSelectCustom : openSelectCustom)()
  };
  
  function watchClickOutside(e) {
    const didClickedOutside = !refs.elSelectCustomWrapper.contains(
      e.target
    );
    if (didClickedOutside) {
      closeSelectCustom();
    }
  }

  const customOptionClickHandler = (e) => {
    const elNewOption = e.target || e.target.closest("[data-value]");
    const { value } = elNewOption.dataset;
    if (!value) return;

    setCurrentCountry(value);
    closeSelectCustom();
    if (document.activeElement !== phoneInputEl) phoneInputEl.focus()
  };

  const phoneInputPasteHandler = (e) => {
    // debugger
    const clipboardData = (e.clipboardData || window.clipboardData).getData(
      "Text"
    );
    const parsedFromClipboardNumber = parsePhoneNumber(clipboardData);
    const formattedNumber = parsedFromClipboardNumber?.format("INTERNATIONAL");
    if (formattedNumber) {
      if (currentCountry?.code !== parsedFromClipboardNumber.country)
        setCurrentCountry(parsedFromClipboardNumber.country);
      formatter.reset();
      inputValue = formatter.input(parsedFromClipboardNumber?.number);
      e.target.value = inputValue;
      e.target.dataset.isValid = formatter.isValid()
      e.preventDefault();
    }
  };

  const phoneInputChangeHandler = (e) => {
    let newValue = phoneInputEl.value;
    if (newValue === inputValue) return;
    if (!newValue.startsWith("+")) {
      newValue = "+" + newValue;
    }
    const isCaretEnd = phoneInputEl.selectionStart === phoneInputEl.value.length;
    const isAppend =
      newValue.length > inputValue.length &&
      newValue.slice(0, inputValue.length) === inputValue;
    if (isAppend) {
      const appended = newValue.slice(inputValue.length);
      inputValue = formatter.input(appended)
      setElValue(phoneInputEl, inputValue)
    } else if (isCaretEnd) {
      formatter.reset();
      inputValue = formatter.input(newValue);
      setElValue(phoneInputEl, inputValue)
    } else {
      // Reset the formatter, but do not reformat.
      // Doing so now will cause the user to loose their cursor position
      // Wait until blur or append to reformat.
      formatter.reset();
      formatter.input(newValue);
      inputValue = newValue;
    }
    // const tmpInputValue
    // setElValue(phoneInputEl, inputValue)
    if (currentCountry?.code !== formatter.country)
      setCurrentCountry(formatter.country, inputValue);

    e.target.dataset.isValid = formatter.isValid()
    
  };

  const phoneInputBlurHandler = (e) => {
    const isValid = e.target.formatter.isValid()
    const number = formatter.getNumberValue()
    let newValue
    if (isValid) {
      formatter.reset()
      newValue = formatter.input(number)
    } else  {
      newValue = formatter.input("")
    }
    e.target.value = newValue
  }


  const init = () => {
    // Check if already inited
    if (refs.parentNode.querySelector(selectors.elSelectCustomWrapper)) return;
    if (phoneInputEl.readOnly) {
      if (phoneInputEl.formatter) return;
      formatter = new AsYouType(initCountryCode || defaultCountryCode);
      phoneInputEl.classList.add("masked");
      setElValue(phoneInputEl, formatter.input(initPhoneNumber || phoneInputEl.value));
      Object.assign(phoneInputEl, { formatter });
      return;
    }

    createCodeSelectorNode();

    // Set refs after render cutom dom nodes
    refs.elSelectCustomOpts = refs.parentNode.querySelector(
      selectors.elSelectCustomOpts
    );
    refs.elSelectCustomTrigger = refs.parentNode.querySelector(
      selectors.elSelectCustomTrigger
    );
    refs.elSelectCustomWrapper = refs.parentNode.querySelector(
      ".hybrid_select_wrapper_js"
    );
    refs.selectEl = refs.parentNode.querySelector("select");
    refs.elFalg = refs.parentNode.querySelector(selectors.elFlag);

    phoneInputEl.classList.add("masked")
    refs.parentNode.setAttribute("for", "")

    // Settings
    setCurrentCountry(initCountryCode || defaultCountryCode);
    // setElValue(phoneInputEl, "+" + currentCountry.callingCode);
    setElValue(refs.selectEl, currentCountry.code);

    // Events
    phoneInputEl.addEventListener("input", phoneInputChangeHandler);
    phoneInputEl.addEventListener("blur", phoneInputBlurHandler);
    phoneInputEl.addEventListener("paste", phoneInputPasteHandler);
    refs.selectEl && refs.selectEl.addEventListener("change", selectChangeHandler);
    refs.elSelectCustomTrigger.addEventListener(
      "click",
      customSelectTriggerClickHandler
    );
    refs.elSelectCustomOpts && refs.elSelectCustomOpts.addEventListener(
      "click",
      customOptionClickHandler
    );
    Object.assign(phoneInputEl, {formatter})
    // .formatter = formatter
  };
  init();
};

function createSelectOptions() {
  const {
    metadata: { countries },
  } = new Metadata();
  const result = [];
  countryWithNames.forEach(({ code, name }) => {
    const callingCode = countries[code]?.[0];
    callingCode &&
      result.push({
        code,
        name,
        callingCode,
      });
  });
  return result;
}

function PhoneInputInit(event, phoneInputEls) {
  let target = phoneInputEls || this

  if (event?.target) ({target} = event)

  if (target instanceof HTMLInputElement) {
    PhoneInput(target)
    return
  } 
  if (typeof target === "string") {
    target = document.querySelectorAll(target)
  } 
  if (target instanceof NodeList) {
    target.forEach((el) => {
      el.value && PhoneInput(el);
    });
  }
}

const isValidPhoneNumberParsed = (value) => {
  const parsed = parsePhoneNumber("+" + value.replace(/\D/g, ""))
  return parsed && parsed.isValid() || false
}

export default PhoneInputInit
export { isValidPhoneNumberParsed as isValidPhoneNumber }